export default "__VITE_ASSET__CauJi$6___"